import './App.css';
import Profile from "./Components/Profile";
/*please*/


function App() {
  return (
        <div className="App">
                <div className="Header">
                <Profile profileImage={require('./images/IMG_3850_SnapseedCopy.jpg')} />
                <h1 className="Intro">Welcome!</h1>
            </div>
        </div>
  );
}

export default App;
